var View = require('views/base/view');
var ToolBarView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: require('./templates/accessibility')
});

module.exports = ToolBarView;